import { CardMedia, Typography, Box, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import { TrackgoodIconSmall } from 'src/assets/icons/v2/TrackgoodSmallIcon';
import { IPublicAccountItem } from 'src/types';

interface IProps {
  account: IPublicAccountItem;
}

export const AccountItem = ({ account }: IProps) => {
  const theme = useTheme();
  const isAIGenerated = account.ai_generated;

  return (
    <Box id="account-item__components-home-accounts-list__box__l17"
    component={RouterLink}
    to={`/account/${account.simple_id}`}
    aria-label={`View account ${account.account_holder}`}
    sx={{
      display: 'block',
      textDecoration: 'none',
      color: 'inherit',
      '&:visited': { color: 'inherit' },
      // hover only affects the INNER box:
      '&:hover .acc-card-inner': {
        transform: 'scale(1.02)',
        borderColor: isAIGenerated ? theme.palette.grey[500] : theme.palette.primary.main
      },
      outline: 0
    }}>
      
      {/* INNER: scaled wrapper to avoid text flicker */}
      <Box id="account-item__components-home-accounts-list__box__l35"
      className="acc-card-inner"
      sx={{
        boxSizing: 'border-box',
        padding: '8px',
        width: '100%',
        cursor: 'pointer',
        border: `2px solid ${theme.palette.grey[200]}`,
        borderRadius: '15px',

        transform: 'translateZ(0) scale(1)',
        willChange: 'transform, border-color',
        backfaceVisibility: 'hidden',
        transition: 'transform 0.3s ease, border 0.3s ease'
      }}>
        
        <Box id="account-item__components-home-accounts-list__box__l51" sx={{ position: 'relative', height: 'auto', boxSizing: 'border-box' }}>
          {isAIGenerated ?
          <Box id="account-item__components-home-accounts-list__box__l53"
          sx={{
            position: 'absolute',
            top: 2,
            right: -3,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            borderRadius: '50%',
            p: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            
              <AutoAwesomeIcon sx={{ width: 20, height: 20, color: theme.palette.grey[700] }} />
            </Box> :

          <Box id="account-item__components-home-accounts-list__box__l69"
          sx={{
            position: 'absolute',
            top: 0,
            right: -5,
            backgroundColor: 'rgba(255, 255, 255, 0.7)',
            borderRadius: '50%',
            p: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            
              <TrackgoodIconSmall height="25px" width="25px" />
            </Box>
          }

          <CardMedia id="account-item__components-home-accounts-list__cardmedia__l86"
          component="img"
          image={account.image_small}
          alt={account.account_holder}
          sx={{
            objectFit: 'contain',
            height: 'auto',
            maxHeight: '100px',
            width: '100%'
          }} />
          
        </Box>

        <Box id="account-item__components-home-accounts-list__box__l99"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '6px',
          p: '8px 4px'
        }}>
          
          <Typography id="account-item__components-home-accounts-list__typography__l108" fontSize="12px" fontWeight={700}>
            {account.account_holder}
          </Typography>
        </Box>
      </Box>
    </Box>);

};